export default "__VITE_ASSET__BDED$drN__"